import { Button } from '@bamboohr/fabric';
import React from 'react';

export interface SsoButtonProps {
	ssoProvider: string;
	buttonRedirectUri: string;
}

export const SsoButton: React.FC<SsoButtonProps> = ({
	ssoProvider,
	buttonRedirectUri,
}) => {
	if (!ssoProvider) {
		return null;
	}

	return (
		<>
			{ssoProvider === 'googleSso' && (
				<div id="googleSSO">
					<Button
						href={`/googleLogin2.php${buttonRedirectUri}`}
						size="large"
						startIcon="google"
						type="button"
						width={9}
					>
						{$.__('Log in with Google')}
					</Button>
				</div>
			)}

			{ssoProvider === 'microsoftSso' && (
				<div id="microsoftSSO">
					<Button
						href={`/sso/microsoft_login${buttonRedirectUri}`}
						size="large"
						startIcon="microsoft"
						type="button"
						width={9}
					>
						{$.__('Log in with Microsoft')}
					</Button>
				</div>
			)}

			{ssoProvider === 'quickbooksOnlinePayroll' && (
				<div id="quickbooksOnlinePayroll">
					<Button
						href={`/sso/qbop_login${buttonRedirectUri}`}
						size="large"
						startIcon="right-to-bracket-regular"
						type="button"
						width={9}
					>
						{$.__('Log in with QuickBooks')}
					</Button>
				</div>
			)}

			{ssoProvider === 'onelogin' && (
				<div id="onelogin">
					<Button
						href={`/saml/index.php${buttonRedirectUri}`}
						size="large"
						type="button"
						width={9}
					>
						{$.__('Log in with OneLogin')}
					</Button>
				</div>
			)}

			{ssoProvider === 'okta' && (
				<div id="okta">
					<Button
						href={`/saml/index.php${buttonRedirectUri}`}
						size="large"
						type="button"
						width={9}
					>
						{$.__('Log in with Okta')}
					</Button>
				</div>
			)}

			{ssoProvider === 'saml' && (
				<div id="saml">
					<Button
						href={`/saml/index.php${buttonRedirectUri}`}
						size="large"
						type="button"
						width={9}
					>
						{$.__('Log in with SAML')}
					</Button>
				</div>
			)}
		</>
	);
};
